import { UserService } from '@/services/UserService';
import { validateEmail } from '@/utils/helper';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../auth.scss';
import HeaderSpace from '../common/header-space/HeaderSpace';
const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    email: '',
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
    handleValidation();
    if (!isFormValid) {
      return;
    }
    UserService.forgotPassword({ email: formData.email, restaurant_id: localStorage.getItem('restaurant_id') || '' }).then((res) => {
      setLoading(false);
      setSubmitted(false);
      if (res.data.status === 'success') {
        setFormData({ email: '' });
      }
    }).catch((err) => {
      setLoading(false);
      setSubmitted(false);
    });
  }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleValidation = useCallback(() => {
    let flag = true;
    const error = {
      email: '',
    };
    if (!formData.email) {
      error.email = 'Email is required';
      flag = false;
    } else {
      if (!validateEmail(formData.email)) {
        error.email = 'Invalid email address';
        setIsFormValid(false);
      } else {
        error.email = '';
        flag = true;
      }
    }
    setIsFormValid(flag);
    setError(error);  
  }, [formData.email]);

  useEffect(() => {
    handleValidation();
  }, [handleValidation, formData.email]);



  return (
    <div className="login-section">
      <HeaderSpace />
      <div className="cs-container">
        <div className="auth-container login-content">
          <div className="login-header">
            <h1>Forgot Password</h1>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="grid grid--1">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className='form-field'>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={submitted && error.email ? 'error' : ''}
                  />
                </div>
              </div>
              <div className="form-options">
                <div className="remember-me">
                  <Link to="/login" className="forgot-password-btn"><i className="cs-icon icon-arrow-left"></i> Back to Login</Link>
                </div>
              </div>
            </div>
            <div className="buttons-group justify-center">
              <button className="btn btn--pri" type="submit" disabled={loading}>Submit</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;